import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopConsumoFormService } from './scheda-coop-consumo-form.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopConsumoFormService],
})
export class SchedaCoopConsumoFormModule {}